export function defaultGraph () {
  return ''
}
